import { useTranslations } from '@vocab/react';
import { Alert, List, Stack, Text } from 'braid-design-system';

import translations from './.vocab';

interface Props {
  message: string | Record<string, string>;
}

export function AlertMessage({ message }: Props) {
  const { t } = useTranslations(translations);
  return (
    <Alert id="errorPanel" tone="critical">
      <Stack space="medium">
        {typeof message === 'object' && (
          <>
            <Text>{t('Before you can')}</Text>
            <List>
              {Object.entries(message).map(([key, value], index) => (
                <Text key={key || index}>
                  {key ? `${key} - ${value}` : value}
                </Text>
              ))}
            </List>
          </>
        )}
        {typeof message === 'string' && <Text>{message}</Text>}
      </Stack>
    </Alert>
  );
}
